class UtilityService {

    copyToClipboard(text) {
        console.log(text);
        document.addEventListener("copy", function (e) {
            e.clipboardData.setData("text/plain", text);
            e.preventDefault();
        });
        document.execCommand("copy");
        alert('Copied to clipboard!')
        // toast.methods.show({
        //     error: false,
        //     msg: "Copied to clipboard!",
        // });
        // this.$router.push(this.Url)
    }

    async share(shareData) {
        // const shareData = {
        //     title: 'MDN',
        //     text: 'Learn web development on MDN!',
        //     url: 'https://developer.mozilla.org'
        // }
        if (navigator.canShare) { // && navigator.canShare({ files: filesArray })
            // const btn = document.querySelector('button');
            // const resultPara = document.querySelector('.result');
            //
            // // Share must be triggered by "user activation"
            // btn.addEventListener('click', async () => {
            try {
                await navigator.share(shareData)
                // resultPara.textContent = 'MDN shared successfully'
            } catch (err) {
                console.log(err)
                // resultPara.textContent = 'Error: ' + err
            }
            // });
        } else {
            if (shareData) {
                this.copyToClipboard(shareData.title + '' + shareData.text + '' + shareData.url)
            } else {
                alert('Sorry, please share it in another way!')
            }

            return false
        }
    }


    isImageFile(fileUrl) {
        let ext = fileUrl.match(/\.[0-9a-z]+$/i)[0]
        let result = ext === '.png' || ext === '.jpg' || ext === '.gif' || ext === '.tif';
        // console.log({
        //     type: 'isImageFile',
        //     // url: fileUrl,
        //     // fragments: fragments,
        //     ext: ext,
        //     result: result,
        // })
        return result;
    }


    isVideoFile(fileUrl) {
        let ext = fileUrl.match(/\.[0-9a-z]+$/i)[0]
        // console.log(ext)
        let result = ext === '.mp4' || ext === '.webm';

        // console.log({
        //     type: 'isVideoFile',
        //     url: fileUrl,
        //     // fragments: fragments,
        //     ext: ext,
        //     result: result,
        // })
        return result;

    }

    is3DObj(fileUrl) {
        let ext = fileUrl.match(/\.[0-9a-z]+$/i)[0]
        let result = ext === '.obj'
        //
        // console.log({
        //     type: 'is3DObj',
        //     url: fileUrl,
        //     // fragments: fragments,
        //     ext: ext,
        //     result: result,
        // })
        return result;

    }

    is3DFBX(fileUrl) {
        let ext = fileUrl.match(/\.[0-9a-z]+$/i)[0]
        let result = ext === '.fbx'
        //
        // console.log({
        //     type: 'is3DObj',
        //     url: fileUrl,
        //     // fragments: fragments,
        //     ext: ext,
        //     result: result,
        // })
        return result;

    }

    // is3DThree(fileUrl) {
    //     let ext = fileUrl.match(/\.[0-9a-z]+$/i)[0]
    //     let result = ext === '.json'
    //
    //     console.log({
    //         type: 'is3DThree',
    //         url: fileUrl,
    //         // fragments: fragments,
    //         ext: ext,
    //         result: result,
    //     })
    //     return result;
    //
    // }
    is3DGLTF(fileUrl) {
        let ext = fileUrl.match(/\.[0-9a-z]+$/i)[0]
        let result = ext === '.gltf' || ext === '.glb'

        // console.log({
        //     type: 'is3DGLTF',
        //     url: fileUrl,
        //     // fragments: fragments,
        //     ext: ext,
        //     result: result,
        // })
        return result;

    }

    // is3DCollada(fileUrl) {
    //     let ext = fileUrl.match(/\.[0-9a-z]+$/i)[0]
    //     let result = ext === '.dae'
    //
    //     console.log({
    //         type: 'is3DCollada',
    //         url: fileUrl,
    //         // fragments: fragments,
    //         ext: ext,
    //         result: result,
    //     })
    //     return result;
    //
    // }


    formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return '0 Bytes';

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

//
    desktopCheck() {
        // wird in share check verwendet um den desctop usern normale scharing links anzu zeigen
        let check = false;
        const regex = new RegExp('/(android|bb\\d+|meego).+mobile|avantgo|bada\\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\\-(n|u)|c55\\/|capi|ccwa|cdm\\-|cell|chtm|cldc|cmd\\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\\-s|devi|dica|dmob|do(c|p)o|ds(12|\\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\\-|_)|g1 u|g560|gene|gf\\-5|g\\-mo|go(\\.w|od)|gr(ad|un)|haie|hcit|hd\\-(m|p|t)|hei\\-|hi(pt|ta)|hp( i|ip)|hs\\-c|ht(c(\\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\\-(20|go|ma)|i230|iac( |\\-|\\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\\/)|klon|kpt |kwc\\-|kyo(c|k)|le(no|xi)|lg( g|\\/(k|l|u)|50|54|\\-[a-w])|libw|lynx|m1\\-w|m3ga|m50\\/|ma(te|ui|xo)|mc(01|21|ca)|m\\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\\-2|po(ck|rt|se)|prox|psio|pt\\-g|qa\\-a|qc(07|12|21|32|60|\\-[2-7]|i\\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\\-|oo|p\\-)|sdk\\/|se(c(\\-|0|1)|47|mc|nd|ri)|sgh\\-|shar|sie(\\-|m)|sk\\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\\-|v\\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\\-|tdg\\-|tel(i|m)|tim\\-|t\\-mo|to(pl|sh)|ts(70|m\\-|m3|m5)|tx\\-9|up(\\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\\-|your|zeto|zte\\-/i.test(a.substr(0, 4))');
        (function (a) {
            if (regex.test(a)) check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check
    }

}

export default new UtilityService()